import React from "react"
export function Shortlisted(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M9.321 17.369l-.481-.448C4.72 13.104 2 10.586 2 7.496 2 4.978 3.936 3 6.4 3c1.392 0 2.728.662 3.6 1.708C10.872 3.662 12.208 3 13.6 3 16.064 3 18 4.978 18 7.496c0 3.09-2.72 5.608-6.84 9.433l-.48.442a1 1 0 01-1.359-.002z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__shortlisted"
        />
      </g>
    </svg>
  )
}
